import trim from "lodash/trim";
import Misc from "../../../../../misc/misc";

export const getShippingValidationErrors = (property, checkValue) => {
  const currentValue = trim(checkValue);
  const errors = [];

  switch (property) {
    case "address1": {
      if (!currentValue) {
        errors.push("look.inputs.errors.noAddress");
        return errors
      }
      break;
    }
    case "postal": {
      if (!currentValue) {
        errors.push("look.inputs.errors.missingPostal");
        return errors
      }
      if (!Misc.isZip(currentValue)) {
        errors.push("look.inputs.errors.incorrectPostal");
        return errors
      }
      break;
    }
  }
  return errors
}
